import { ActionTypes } from '../constants/index';

export const getContentManagement = () => ({
  type: ActionTypes.CONTENT_MGMT_LIST_REQUEST,
});
